// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010902/js/" + chunkId + "." + {"44":"dc4e3701","225":"9c197f27","481":"1c00a923","486":"9eee0413","770":"d5af75e4"}[chunkId] + ".0.24916401510305042.chunk.js";
};